<template>
    <v-container fluid>
        <div class="bonus-details-box">
            <div class="bonus-header">Re-Evaluate</div>
            <div>
                <v-row>
                    <v-col cols="12">
                        <div>Are you sure you want to re-evaluate marks for {{data.testId ? data.overAllInfo.testName : ""}} ?</div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex justify-start">
                            <v-btn  class="cust-btn btn-uppercase" color="primary" @click="reevaluate()" >Re-Evaluate</v-btn >
                            <v-btn class="mx-4" color="secondary" @click="onClose({ status: false })" >
                                Cancel
                            </v-btn >
                        </div>
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "ReEvaluateMarks",
    props: ["onClose", "status", "data"],
    data() {
        return {};
    },
    mounted() {},
    methods: {
        ...mapActions({
            reevaluateMarks: "testStore/reevaluateMarks",
        }),
        reevaluate() {
            let postData = {
                schedule_id: this.data.scheduleId,
            };
            this.reevaluateMarks(postData)
                .then((response) => {
                    this.$toasted.success("Marks Re-evaluated successfully.");
                    this.onClose({status: false});
                })
                .catch((err) => {
                    this.$toasted.error(
                        "Error re-evaluationg marks. Please try again"
                    );
                });
        },
    },
    computed: {},
};
</script>